import React from'react';import {useIntl}from'react-intl';import {Footer as Footer$2}from'@manulife/mux';import useCoBranding from'../../hooks/useCoBranding.js';var Footer = function Footer() {
  var _coBranding$brand, _coBranding$brand2;
  var intl = useIntl();
  var coBranding = useCoBranding();
  var footerItems = [{
    id: 'accessibility',
    title: intl.formatMessage({
      id: 'shared.layout.footer.accessibility.title'
    }),
    href: (coBranding === null || coBranding === void 0 ? void 0 : (_coBranding$brand = coBranding.brand) === null || _coBranding$brand === void 0 ? void 0 : _coBranding$brand.accessibilityUrl) || intl.formatMessage({
      id: 'shared.layout.footer.accessibility.href'
    }),
    isExternal: true
  }, {
    id: 'legal',
    title: intl.formatMessage({
      id: 'shared.layout.footer.legal.title'
    }),
    href: intl.formatMessage({
      id: 'shared.layout.footer.legal.href'
    }),
    isExternal: true
  }, {
    id: 'toc',
    title: intl.formatMessage({
      id: 'shared.layout.footer.toc.title'
    }),
    href: intl.formatMessage({
      id: 'shared.layout.footer.toc.href'
    }),
    isExternal: true
  }, {
    id: 'privacy',
    title: intl.formatMessage({
      id: 'shared.layout.footer.privacy.title'
    }),
    href: (coBranding === null || coBranding === void 0 ? void 0 : (_coBranding$brand2 = coBranding.brand) === null || _coBranding$brand2 === void 0 ? void 0 : _coBranding$brand2.privacyPolicyUrl) || intl.formatMessage({
      id: 'shared.layout.footer.privacy.href'
    }),
    isExternal: true
  }];
  return /*#__PURE__*/React.createElement(Footer$2, {
    id: "footer",
    items: footerItems
  });
};
var Footer$1 = Footer;export{Footer$1 as default};